import styled from "styled-components";
import { ErrorText as BaseErrorText } from "../../input/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 440px;
  max-width: 100%;
  background-color: ${({ theme }) => theme.base.white};
  border-radius: 12px;
  box-shadow: 0px 20px 60px rgba(15, 23, 42, 0.18);
`;

export const HeadWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 12px;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
`;

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
`;

export const CurrentConfiguration = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 8px;
`;

export const ErrorText = styled(BaseErrorText)`
  margin-top: -8px;
`;
